import { SEND_OTP } from "../actionTypes";

export function sendOtp(data,callback) {
  return {
    type: SEND_OTP,
    data,
    callback
  };
}
